import { combineReducers } from "redux";
import reportCampaign from "./reportCampaign";

export default combineReducers({
  reportCampaign,
});
